// A face-down card: just its back, showing the age (e.g. an opponent's military card, or a prepared event).
// title: hover text, e.g. the card's name when the one looking knows it.
const AgeNumerals = { 'Age A': 'A', 'Age I': 'I', 'Age II': 'II', 'Age III': 'III', 'Age IV': 'IV' };

function CardBack({ age, title, known = false })
{
    return (
        <div className={`tta-card-back${known ? ' known' : ''}`} title={title ?? `${age} card, face down`}>
            {AgeNumerals[age] ?? '?'}
        </div>
    );
}

export default CardBack;
